<template>
  <div>
    <a-modal v-model="visible" width="420px" :title="groupId ? '修改组' : '添加组'" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="名称" prop="name">
          <a-input v-model="modalForm.name" />
        </a-form-model-item>
        <a-form-model-item label="标识" prop="code">
          <a-input v-model="modalForm.code" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort">
          <a-input-number v-model="modalForm.sort" style="width: 100%" :min="1" :max="100000" :default-value="1" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { tagGroupModify, tagGroupAdd } from '@/api/system/tag';

export default {
  props: {
    groupId: {
      type: [Number, String],
      default: null
    },
    groupData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      uplaadLoading: false,
      visible: this.isShow,
      labelCol: { span: 8 },
      wrapperCol: { span: 13 },
      modalForm: {
        logo: null
      },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '标识不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        if (this.groupId) {
          this.modalForm = {
            ...this.groupData
          };
        } else {
          this.modalForm = {
            name: null,
            code: null,
            sort: 1
          };
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('close', 'submit');
    },

    submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.groupId) {
            this.loading = true;
            tagGroupModify({ id: this.groupId, ...this.modalForm })
              .then(() => {
                this.loading = false;
                this.$message.success('更新成功');
                this.close();
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            tagGroupAdd(this.modalForm)
              .then(() => {
                this.$message.success('添加成功');
                this.close();
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-modal-body) {
  padding: 16px 32px 0px 16px;
}
</style>
